import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {  useLocation, useNavigate, useParams } from "react-router-dom";
import { fetchDimensions, setFilterDimensions,toogleDataCheck } from "../../store/app/DataQualityStatus/DataQualitySlice";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import PropTypes from 'prop-types';


const DimensionsSelector = () => {
  const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const searchParams = new URLSearchParams(location.search);
	const refreshCount = useSelector(  (state) => state.dataQualityReducer.refreshCount   )
  const { versionId } = useParams();

  
	useEffect(() => {
    dispatch(fetchDimensions(versionId));
		// get parameters from url query
		let value
		try{
			value = JSON.parse(searchParams.get('dimensions')) || []
		}catch (error){
			value = props.defaultValue || []
			console.error (error)
		}

    dispatch (setFilterDimensions(value))
  }, [navigate, refreshCount]);



  const dimensions = useSelector( (state) => state.dataQualityReducer.dimensions );

  const stateValue = useSelector( (state) => state.dataQualityReducer.filterDimensions );

  let selectedIds = dimensions?.reduce ((accumulator, item) => { 
    if (stateValue?.findIndex ((sparam) => sparam == item.id) != -1){
      accumulator.push (item.id)
    }
    return accumulator
  }, [] )


  /**
   * Gestisce il cambio selezione
   * @param {*} event 
   */
  const handleChange = (event) => {

    const currentSelectAll = event.value.some((i) => i.id === null);

    if (currentSelectAll){
      const tutti = event.value.length == dimensions.length
      if (tutti){
        selectedIds = []
      } else {
        selectedIds = dimensions.map ( (item) => item.id)
        selectedIds.shift()        
      }
    } else {
      selectedIds = event.value.map ( (item) => item.id)
    }

    dispatch (setFilterDimensions(selectedIds))
    dispatch (toogleDataCheck(true))
  };

  /**
   * Render di un elemento
   * @param {*} li 
   * @param {*} itemProps  L'elemento da visualizzare
   * @returns 
   */
  const itemRender = (li, itemProps) => {
    const itemChildren = (
      <span className="form-check py-1">
					<input
            id={`filter_dimensions_id_${itemProps.index}`}
						type="checkbox"
						checked={itemProps.selected}
						onChange={(e) => itemProps.onClick(itemProps.index, e)}
						className="form-check-input"
					/>
          <label className="form-check-label">
					&nbsp;{itemProps.dataItem.description}
				</label>
      </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
  };


  const value = dimensions?.reduce ((accumulator, item) => { 
    if (selectedIds.findIndex ((sparam) => sparam == item.id) != -1){
      accumulator.push (item)
    }
    return accumulator
  }, [] )

  const selected = value.length;


   let tags;
  if (selected > 0) {
    if (selected === 1 && value.length === 1) {
      tags = [
        {
          text: value[0].text || value[0].id || "1 selezionato",
          data: [...value],
        },
      ];
    } else {
      tags = [
        {
          text: `${selected}  selezionati`,
          data: [...value],
        },
      ];
    }
  } else {
    tags = [
      {
        text: `Nessuna dimensione selezionata`,
        data: [...value],
      },
    ];
  }

	return (
    <MultiSelect
      data={dimensions}
      autoClose={true}
      itemRender={itemRender}
      value={value}
      onChange={handleChange}
      dataItemKey="id"
      textField="description"
      tags={tags}
      size="large"
    />

	)
};

export default DimensionsSelector;